import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_DenominationsList = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 12px;
  overflow-x: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SC_DenominationItem = styled.div<{ $isSelected: boolean }>`
  padding: 13px 23px;
  font-size: 18px;
  background-color: ${(p) => p.$isSelected ? E_Colors.MainColorAccent : E_Colors.GrayF2};
  ${(p) => p.$isSelected ? `color: ${E_Colors.White}` : ''};
  border-radius: 12px;
  white-space: pre;
  cursor: pointer;
`

export const SC_StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 12px;
  padding-right: 48px;
`

export const SC_Step = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;

  div {
    width: 40px;
    height: 40px;
    background-color: ${E_Colors.MainColorAccent};
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const SC_VertLine = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${E_Colors.GrayB7BEBE};
  margin: 4px 0 4px 20px;
`

export const SC_ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SC_DrawerContent = styled.div`
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;

  -ms-overflow-style: none; 
  scrollbar-width: none;  

  &::-webkit-scrollbar {
    display: none;        
  }
`
